module.exports = __webpack_public_path__ + "static/media/iconmonstr-instagram-12.a0d02930.png";